// extracted by mini-css-extract-plugin
export default {"wrapper":"knowleageBaseArticle_wrapper__sHPnw","tag":"knowleageBaseArticle_tag__Me6MS"};